const COLORS = { 1: "#EF4444", 2: "#F59E0B", 3: "#3B82F6", 4: "#10B981" };
const TEXT = "#111827";
const MUTED = "#4b5563";
const BREAK = "#B91C1C";
const R = 18;

const Union = ({ u, x1, y1, x2, y2 }) => {
  const color = COLORS[u.nivel];
  if (u.estilo === "rota") {
    const vertical = x1 === x2;
    const mx = (x1 + x2) / 2;
    const my = (y1 + y2) / 2;
    const g = 8;
    const a = vertical ? { x: mx, y: my - g } : { x: mx - g, y: my };
    const b = vertical ? { x: mx, y: my + g } : { x: mx + g, y: my };
    const tick = (cx, cy) => (vertical
      ? <line x1={cx - 7} y1={cy - 3} x2={cx + 7} y2={cy + 3} stroke={color} strokeWidth={2} />
      : <line x1={cx - 3} y1={cy - 7} x2={cx + 3} y2={cy + 7} stroke={color} strokeWidth={2} />);
    return (
      <g data-estilo="rota">
        <line x1={x1} y1={y1} x2={a.x} y2={a.y} stroke={color} strokeWidth={2.5} />
        <line x1={b.x} y1={b.y} x2={x2} y2={y2} stroke={color} strokeWidth={2.5} />
        {tick(a.x, a.y)}
        {tick(b.x, b.y)}
      </g>
    );
  }
  return (
    <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} data-estilo={u.estilo}
      strokeWidth={u.estilo === "gruesa" ? 5 : 2.5} strokeDasharray={u.estilo === "discontinua" ? "6 5" : undefined} />
  );
};

const Node = ({ e, x, y }) => (
  <circle cx={x} cy={y} r={R} fill={e.nivel === 4 ? COLORS[4] : "#fff"} stroke={COLORS[e.nivel]} strokeWidth={3} />
);

const markColor = (debil) => (debil.nivel <= 2 ? BREAK : MUTED);

export const CadenaHorizontal = ({ cadena, cambios }) => {
  const step = 110;
  const xs = cadena.eslabones.map((_, i) => 55 + i * step);
  const y = 70;
  const h = cambios ? 190 : 150;
  const d = cadena.debil;
  return (
    <svg viewBox={`0 0 660 ${h}`} className="w-full h-auto" role="img" aria-label={cadena.descripcion} data-testid="cadena-svg-horizontal">
      {cadena.uniones.map((u, i) => <Union key={i} u={u} x1={xs[i] + R} y1={y} x2={xs[i + 1] - R} y2={y} />)}
      {cadena.eslabones.map((e, i) => (
        <g key={e.code} data-testid={`cadena-node-${e.code}`} aria-label={`${e.nombre}: ${e.label}`}>
          <Node e={e} x={xs[i]} y={y} />
          <text x={xs[i]} y={y + 38} textAnchor="middle" fontSize="13" fontWeight="700" fill={TEXT}>{e.corto}</text>
          <text x={xs[i]} y={y + 55} textAnchor="middle" fontSize="12" fill={MUTED}>{e.label}</text>
          {cambios && (
            <foreignObject x={xs[i] - 54} y={y + 64} width="108" height="56">
              <div style={{ fontSize: 10, lineHeight: 1.25, color: MUTED, textAlign: "center" }} data-testid={`cadena-cambio-${e.code}`}>{cambios[e.code]}</div>
            </foreignObject>
          )}
          {e.code === d.code && d.marca && (
            <>
              <text x={xs[i] + (i === 0 ? -R : i === 5 ? R : 0)} y={y - 34} textAnchor={i === 0 ? "start" : i === 5 ? "end" : "middle"} fontSize="12" fontWeight="700" fill={markColor(d)} data-testid="cadena-marca">{d.marca}</text>
              <path d={`M${xs[i] - 5},${y - 28} L${xs[i] + 5},${y - 28} L${xs[i]},${y - 22} Z`} fill={markColor(d)} />
            </>
          )}
        </g>
      ))}
    </svg>
  );
};

export const CadenaVertical = ({ cadena, cambios }) => {
  const step = cambios ? 108 : 78;
  const x = 34;
  const ys = cadena.eslabones.map((_, i) => 30 + i * step);
  const d = cadena.debil;
  return (
    <svg viewBox={`0 0 320 ${ys[5] + 50}`} className="w-full h-auto" role="img" aria-label={cadena.descripcion} data-testid="cadena-svg-vertical">
      {cadena.uniones.map((u, i) => <Union key={i} u={u} x1={x} y1={ys[i] + R} x2={x} y2={ys[i + 1] - R} />)}
      {cadena.eslabones.map((e, i) => (
        <g key={e.code} aria-label={`${e.nombre}: ${e.label}`} data-testid={`cadena-v-node-${e.code}`}>
          <Node e={e} x={x} y={ys[i]} />
          <text x={x + 32} y={ys[i] - 2} fontSize="14" fontWeight="700" fill={TEXT}>{e.corto}</text>
          <text x={x + 32} y={ys[i] + 16} fontSize="13" fill={MUTED}>{e.label}</text>
          {e.code === d.code && d.marca && (
            <text x={x + 32} y={ys[i] - 20} fontSize="12" fontWeight="700" fill={markColor(d)} data-testid="cadena-v-marca">{d.marca}</text>
          )}
          {cambios && (() => {
            const [a, b] = cambios[e.code].split(": ");
            return (
              <text x={x + 32} y={ys[i] + 34} fontSize="11" fill={MUTED}>
                <tspan x={x + 32}>{b ? `${a}:` : a}</tspan>
                {b && <tspan x={x + 32} dy="14">{b}</tspan>}
              </text>
            );
          })()}
        </g>
      ))}
    </svg>
  );
};
